// eslint-disable-next-line import/prefer-default-export
export const columns = [
    {
        id: 'imModel',
        visible: true
    },
    {
        id: 'silo',
        visible: true
    },
    {
        id: 'riskClass',
        visible: true
    },
    {
        id: 'senstivity',
        visible: true
    },
    {
        id: 'bucket',
        visible: true
    },
    {
        id: 'trades',
        visible: true
    },
    {
        id: 'imPledgeUsd',
        visible: true
    },
    {
        id: 'imReceiveUsd',
        visible: true
    },
    {
        id: 'imPledgeEur',
        visible: true
    },
    {
        id: 'imReceiveEur',
        visible: true
    }
];

export const dummyRows = [
    {
        id: '',
        imModel: 'CSA 1234 A long name that spans across cells '
    },
    {
        id: 123, imModel: 'SIMM', children: [234, 23411], level: 0, childIndex: 0, expanded: false

    },
    {
        id: 234, silo: 'Equity', children: [345], level: 1, parentId: 123, childIndex: 0, expanded: true

    },
    {
        id: 345, riskClass: 'Commodity', children: [456, 4561, 4562], level: 2, parentId: 234, childIndex: 0, expanded: true

    },
    {
        id: 456, sensitivtyType: 'Delta', bucket: 5, children: [null, null], level: 3, parentId: 345, childIndex: 0, expanded: true

    },
    {
        bucket: 8, level: 4, parentId: 456, childIndex: 0, expanded: true

    }, {
        bucket: 3, level: 4, parentId: 456, childIndex: 1, expanded: true

    },
    {
        id: 4561, sensitivtyType: 'Curvature', bucket: 2, children: [], level: 3, parentId: 345, childIndex: 1, expanded: true

    },
    {
        id: 4562, sensitivtyType: 'Vega', bucket: 8, children: [], level: 3, parentId: 345, childIndex: 2, expanded: true

    },
    {
        id: 23411, silo: 'IR_FX', children: [34511], level: 1, parentId: 123, childIndex: 1, expanded: true

    },
    {
        id: 34511, riskClass: 'FX', children: [45611], level: 2, parentId: 23411, childIndex: 0, expanded: true

    },
    {
        id: 45611, sensitivtyType: 'Delta', bucket: 5, children: [null, null], level: 3, parentId: 34511, childIndex: 0, expanded: true

    },
    {
        bucket: 8, level: 4, parentId: 45611, childIndex: 0, expanded: true

    },
    {
        bucket: 3, level: 4, parentId: 45611, childIndex: 1, expanded: true
    }
];
